module.exports = __webpack_public_path__ + "img/Screenshot from 2020-09-19 10-11-49.72b5e11c.png";